export default __webpack_public_path__ + "fce053f854c92005feaa93744ba079de.png";